import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import App from './App';
import './styles/global.css';

// amplify_outputs.json is generated by Amplify CI/CD (prod) or `npx ampx sandbox` (dev).
fetch('/amplify_outputs.json')
  .then((res) => (res.ok ? res.json() : null))
  .then((config) => {
    if (config) Amplify.configure(config);
  })
  .catch(() => {})
  .finally(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  });
